import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import type { User } from '../types'

export function useLeaderboard() {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function fetchLeaderboard() {
      try {
        const { data, error } = await supabase
          .from('users')
          .select('*')
          .order('points', { ascending: false })
          .limit(100)

        if (error) throw error
        setUsers(data || [])
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch leaderboard'))
      } finally {
        setLoading(false)
      }
    }

    fetchLeaderboard()
  }, [])

  return { users, loading, error }
}